// src/hooks/usePaymentPersons.js
import { useState, useEffect, useContext } from 'react';
import { AuthContext, API_CONFIG } from '../App';

export const usePaymentPersons = () => {
  const { userId } = useContext(AuthContext);
  const [paymentPersons, setPaymentPersons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPaymentPersons = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_CONFIG.USERS_LIST_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('auth_token') || ''}`
        },
        body: JSON.stringify({
          userId: parseInt(userId) || 0
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.success === true) {
        const users = data.data || [];
        const mappedUsers = users.map(user => ({
          id: user.id,
          name: user.username || user.name || `User ${user.id}`
        }));
        setPaymentPersons(mappedUsers);
        return mappedUsers;
      } else {
        // If API fails, use fallback users
        const fallbackUsers = [
          { id: 1, name: 'Shivpuri Account' },
          { id: 2, name: 'Rahul Bagwari' },
          { id: 3, name: 'Kuldeep Bagwari' },
          { id: 4, name: 'Bhagat Singh Bagwari' }
        ];
        setPaymentPersons(fallbackUsers);
        return fallbackUsers;
      }
    } catch (error) {
      console.error('Error fetching payment persons:', error);
      setError(error.message);
      // Fallback to default users
      const fallbackUsers = [
        { id: 1, name: 'Shivpuri Account' },
        { id: 2, name: 'Rahul Bagwari' },
        { id: 3, name: 'Kuldeep Bagwari' },
        { id: 4, name: 'Bhagat Singh Bagwari' }
      ];
      setPaymentPersons(fallbackUsers);
      return fallbackUsers;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentPersons();
  }, []);

  return { paymentPersons, loading, error, fetchPaymentPersons };
};